export const getEditorStateContent = (editorState: any, contentState: any) => {
    if (editorState.getCurrentContent().getPlainText() === "") {
        return "";
    } else {
        return contentState;
    }
};
